//NewsExpanded.tsx
import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NewsLists from './NewsLists'; 
import theme from '../../../../style/theme';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';


/**
 * お知らせアコーディオンコンポーネント
 * - NewsListsコンポーネントをアコーディオン形式で包み、デフォルト展開で表示する
 */
export default function AccordionExpandDefault() {
  
  return (
     <div>
       <Accordion defaultExpanded
         >

        <AccordionSummary
           sx={{
             background: theme.palette.custom.lightOrange,
              
           }}
          className="MuiAccordionSummary-customAccordionSummary"
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
           <Typography variant="h3" color='#666666'
          >ニュース</Typography>
         </AccordionSummary >
         {/* </Box> */}
         <AccordionDetails
      
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            overflow: "hidden", // コンテンツのはみ出しを防ぐ
          }}
         
         >
           <Box sx={{ width: "100%" }}>
           <NewsLists/>
           </Box>
         </AccordionDetails>
       </Accordion>
     </div>
   );
 }
